import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';

import classnames from "classnames";

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";
import PaginationComponent from '../../variables/PaginationComponent.js'; // Pagination 컴포넌트 임포트

import '../../assets/css/Board.css'

// reactstrap components
import {
  Table,
  Input,
  InputGroupText,
  InputGroup,
  Button,
} from "reactstrap";

import {
  Link,
  useNavigate
} from "react-router-dom";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownZA } from "@fortawesome/free-solid-svg-icons"
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"

export default function ContactList() {

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [column, setColumn] = useState('created_at');
  const [direction, setDirection] = useState('desc');

  const [dateIsOn, setDateIsOn] = useState(true);
  const [dateIsDesc, setDateIsDesc] = useState(false);
  const [titleIsOn, setTitleIsOn] = useState(false);
  const [titleIsDesc, setTitleIsDesc] = useState(false);

  /* 최초 자료실 접근 시 로그인 권한 확인 */
  useEffect(() => {

    // 서버에서 게시글 데이터 가져오는 로직
    async function selectContactList() {
      //로딩중 표기
      setIsLoading(true);

      try {
        const response = await axios.get(`/contact/selectContactList?page=${currentPage}&column=${column}&direction=${direction}`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });
        const data = response.data;

        //console.log("Posts Return : " + JSON.stringify(data.results));
        //console.log("Role Check Result : " + data.userRole);
        
        // 접근 사용자 권한 체크
        if(data.userRole !== "") {
          setPosts(data.results);
          setTotalPages(data.totalPages);
          //console.log(posts);
          
          // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
          setIsLoading(false);
        } else {
          //로그인이 안된 상태인 경우, 로그인 페이지로 안내
          alert("해당 메뉴는 로그인 후에 사용 가능합니다. 로그인 페이지로 이동합니다");
          navigate("/Login");
        }

      } catch (error) {
        console.error('게시글 목록 조회 오류:', error);
      }
    }

    // 접근권한 확인을 위한 get-session 이후 실행(1초)
    setTimeout(() => {
      selectContactList();
    }, 10); // 시간을 밀리초 단위로 설정 (1초 = 1000 밀리초)
  }, [currentPage]);

  /* 게시판 정렬 소스 Start */
  useEffect(() => {
    setTimeout(() => {

    // 정렬에 따른 date / title color 세팅
    var dateElements = document.getElementsByName("dateDirection");
    var dateColor;

    dateIsOn === true ? dateColor = "white" : dateColor = "grey";
    
    for (var i = 0; i < dateElements.length; i++){
      dateElements[i].style.color = dateColor;
    }

    var titleElements = document.getElementsByName("titleDirection");
    var titleColor;

    titleIsOn === true ? titleColor = "white" : titleColor = "grey";

    for (var j = 0; j < titleElements.length; j++){
      titleElements[j].style.color = titleColor;
    }

    // 자료실 접근 시 이중호출로 인하여 function 분리
    async function selectContactListByOrder() {
      try {
        const response = await axios.get(`/contact/selectContactList?page=${currentPage}&column=${column}&direction=${direction}`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });
          const data = response.data;
          //console.log(data.results);
          setPosts(data.results);
          setTotalPages(data.totalPages);
          
      } catch (error) {
        console.error('게시글 목록 정렬 오류:', error);
      }
    }

    selectContactListByOrder();
    
    }, 50);
  }, [dateIsOn, dateIsDesc, titleIsOn, titleIsDesc]);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {

  }, [totalPages])

  const DateOrderToggle = () => {
    setDateIsOn(true);
    setTitleIsOn(false);

    setDateIsDesc(!dateIsDesc);
    setColumn('created_at');
    dateIsDesc === true ? setDirection('desc') : setDirection('asc');
  }

  const TitleOrderToggle = () => {
    setDateIsOn(false);
    setTitleIsOn(true);

    setTitleIsDesc(!titleIsDesc);
    setColumn('subject');
    titleIsDesc === true ? setDirection('desc') : setDirection('asc');
  }
  /* 게시판 정렬 소스 END */

  /* 게시판 검색 */
  const [searchText, setSearchText] = useState('');
  const [searchFocus, setSearchFocus] = useState(false);

  // 서버로 검색어를 보내고 검색 결과를 받아오는 함수
  async function searchResults() {
    try {
      const response = await axios.get(`/contact/selectBoard?page=1&column=${column}&direction=${direction}&searchText=${searchText}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      });

      const data = response.data;
      console.log(data.results);
      setPosts(data.results);
      setTotalPages(data.totalPages);

    } catch (error) {
      console.error('검색 중 오류 발생: ', error);
    }
  }
  
  // 검색버튼을 누르거나
  const searchClick = () => {
    searchResults();
  }
  // 검색창에서 엔터키를 누르면 수행
  const handleKeyDown = (e) => {
    if (e.key === 'Enter'){
      searchResults();
    }
  }

  return (
    <>
      <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />
            <div id="ContactList" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Contact List</div>
                    <div className="SectionHeaderTitle">문의리스트</div>
                    <div className="SectionHeaderDescription">
                      서비스 문의를 통해 사용자가 문의한 내역을 확인합니다
                    </div>
                    </div>
                </div>
                
                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {/* 게시글 목록 표시 */}
                    {isLoading ? (
                      // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    ) : (<></>)}
                    <div className="SectionTableContents">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="td-id">No</th>
                              <th>제목&nbsp;&nbsp;
                              {titleIsDesc === true ?
                                <FontAwesomeIcon  name="titleDirection" onClick={ TitleOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownAZ} /> :
                                <FontAwesomeIcon  name="titleDirection" onClick={ TitleOrderToggle } style={{cursor:'pointer', color:'grey'}} icon={faArrowDownZA} />
                              } 
                              </th>
                              <th className="td-writer">문의자</th>
                              <th className="td-writer">문의이메일</th>
                              <th className="td-writer">연락처</th>
                              <th className="td-date">전송일&nbsp;&nbsp;
                              {dateIsDesc === true ?
                                <FontAwesomeIcon name="dateDirection" onClick={ DateOrderToggle } style={{cursor:'pointer', color:'white'}} icon={faArrowDownAZ} /> :
                                <FontAwesomeIcon name="dateDirection" onClick={ DateOrderToggle } style={{cursor:'pointer', color:'white'}} icon={faArrowDownZA} />
                              }
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {posts && posts.map((post, index) => {
                              return(
                                  <tr key={index} id={post.id}>
                                    <td className="td-id">{post.rownum}</td>
                                    <td className="td-title">
                                    <Link to={`/ContactView/${post.id}`}>
                                      {post.subject}
                                    </Link>
                                    </td>
                                    <td className="td-writer">{post.name}</td>
                                    <td className="td-writer">{post.email}</td>
                                    <td className="td-writer">{post.phone}</td>
                                    <td className="td-date">{moment(post.created_at, 'YYYY-MM-DD HHmmss').format('YYYY-MM-DD')}</td>
                                  </tr>
                              )
                              })
                            }
                            {posts.length === 0 ? (
                                <tr>
                                  <td colSpan="5">게시글이 없습니다</td>
                                </tr>
                            ):(<></>)}
                          </tbody>
                        </Table>
                    </div>
                    
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />

                    <div className='boardSearchArea'>
                      <InputGroup
                        className={classnames({
                          "input-group-focus": searchFocus,
                        })}
                      >
                        <InputGroupText>
                          <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </InputGroupText>
                        <Input
                          placeholder="이름/제목/내용 검색"
                          type="text"
                          id="searchText"
                          name= "searchText"
                          onChange={(e) => setSearchText(e.target.value)}
                          onFocus={(e) => setSearchFocus(true)}
                          onBlur={(e) => setSearchFocus(false)}
                          onKeyDown={handleKeyDown}
                        />
                      </InputGroup>
                      <Button type="text" className="itsBtnDefault boardSearchBtn" size="md" onClick={searchClick}>
                        검색
                      </Button>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer/>
    </>
  );
}
